import { OmnibarEntry } from '../omnibar-interfaces';
import { ResourceAction } from '../../../authentication/authorization-service';
import { AllowedActions } from '../../../authentication/allowed-actions';

export default function entryAccessFilter(
  item: OmnibarEntry,
  isTenantAddonEnabled: (addonNames: string[]) => boolean,
  isFeatureEnabled: <T extends string = string>(featureName: T) => boolean,
  allowedActions: AllowedActions,
  hasServiceProviderAreaAccess = false,
  hasServiceProviderRole = false
) {
  if (!checkUserHasAccess(item.resourceActions, allowedActions)) {
    return false;
  }
  if (item.featureToggleRequired) {
    const requiredToggles = Array.isArray(item.featureToggleRequired) ? item.featureToggleRequired : [item.featureToggleRequired];
    if (!requiredToggles.every(toggle => isFeatureEnabled(toggle))) {
      return false;
    }
  }

  if (item.requiresServiceProviderAreaAccess && !hasServiceProviderAreaAccess) {
    return false;
  }

  if (item.requiresServiceProviderRole && !hasServiceProviderRole) {
    return false;
  }

  if (item.tenantAddonEnabled) {
    return isTenantAddonEnabled(item.tenantAddonEnabled);
  }

  return true;
}

function checkUserHasAccess(actions: ResourceAction[] | undefined, allowedActions: AllowedActions) {
  if (actions) {
    return allowedActions.isAnyAllowed(actions);
  }

  return true;
}
